import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import {
  LogosQuery,
  MarkdownRemarkFrontmatter,
} from '../../types/graphql-types';

const LogosDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 40px 0;
  background-color: #fff;
`;

const LOGOS_QUERY = graphql`
  query Logos {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "logos" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            templateKey
            logosList {
              logoImage {
                publicURL
              }
            }
          }
        }
      }
    }
  }
`;

type LogoImageProps = Pick<MarkdownRemarkFrontmatter, 'logoImage'>;

const logos = (logosList: LogoImageProps[]) => {
  return logosList.map((logo: LogoImageProps, index: number) => {
    const imagePath = logo.logoImage?.publicURL;
    return (
      <div key={index}>
        <img src={imagePath ?? ''} />
      </div>
    );
  });
};

const Logos: React.FC = () => {
  const logosList = useStaticQuery<LogosQuery>(LOGOS_QUERY).allMarkdownRemark
    .edges[0].node.frontmatter?.logosList;

  return <LogosDiv>{logos(logosList as LogoImageProps[])}</LogosDiv>;
};

export default Logos;
